/**
 * © 2025 ZOODONIX TECHNOLOGIES (OPC) PRIVATE LIMITED
 * All rights reserved.
 *
 * This software may not be copied, modified, distributed, or used
 * in any form without the express written permission of the copyright holder.
 *
 * Unauthorized use is strictly prohibited.
 */

import './App.css';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import MainRouter from './components/MainRouter';
// import 'bootstrap/dist/css/bootstrap.min.css';
import store, { persistor } from './Store';
// import FloatingWhatsAppIcon from './components/resuableComponents/FloatingWhatsAppIcon';
import { PersistGate } from 'redux-persist/integration/react';
function App() {
	return (
		<>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
					<MainRouter />
					{/* <FloatingWhatsAppIcon /> */}
				</BrowserRouter>
				</PersistGate>
			</Provider>
		</>
	);
}

export default App;
